import Swiper from 'swiper';
import {
	Navigation,
	Pagination,
	Autoplay,
	EffectFade,
	Scrollbar,
	Mousewheel,
} from 'swiper/modules';

Swiper.use([
	Pagination,
	Navigation,
	Autoplay,
	EffectFade,
	Scrollbar,
	Mousewheel,
]);

const swiperSliderLogos = (selector) => {
	const swiperSliders = document.querySelectorAll(selector);

	swiperSliders.forEach((slider) => {
		// Skip initialization if the slider has the 'disabled' attribute
		if (slider.hasAttribute('disabled')) {
			return;
		}

		// Get nearest slider section and count slides
		let nearestSlider = slider.closest('section');
		let slidesCount = slider.querySelectorAll('.swiper-slide').length;

		// Initialize Swiper
		const swiper = new Swiper(slider, {
			modules: [Autoplay],
			loop: true,
			speed: 5000,
			autoplay: {
				delay: 0,
				disableOnInteraction: false,
				pauseOnMouseEnter: false,
			},
			freeMode: {
				enabled: true,
				momentum: false,
			},
			spaceBetween: 40,
			breakpoints: {
				0: {
					slidesPerView: 1,
				},
				768: {
					slidesPerView: 3,
				},
				1280: {
					slidesPerView: 6,
				},
			},
		});
	});
};
swiperSliderLogos('.swiper-slider-logos');

const swiperLogosCarousel = (selector) => {
	const swiperSliders = document.querySelectorAll(selector);
	swiperSliders.forEach((slider) => {
		let nearestSlider = slider.closest('section');
		let slidesCount = slider.querySelectorAll('.swiper-slide').length;

		const swiper = new Swiper(slider, {
			modules: [Autoplay],
			loop: true,
			speed: 10000,
			autoplay: {
				delay: 0,
				disableOnInteraction: false,
				pauseOnMouseEnter: false,
				waitForTransition: true,
			},
			freeMode: {
				enabled: true,
				momentum: false,
			},
			resistanceRatio: 0,
			spaceBetween: 40,
			breakpoints: {
				0: {
					slidesPerView: 2,
					spaceBetween: 20,
				},
				768: {
					slidesPerView: 3,
					spaceBetween: 30,
				},
				1280: {
					slidesPerView: 5,
					spaceBetween: 40,
				},
			},
		});
	});
};
swiperLogosCarousel('[data-swiper-logos]');

const swiperTimeline = (selector) => {
	const swiperSliders = document.querySelectorAll(selector);
	swiperSliders.forEach((slider) => {
		const pagination = slider.closest('section').querySelector('.swiper-pagination');
		let slidesCount = slider.querySelectorAll('.swiper-slide').length;

		const swiper = new Swiper(slider, {
			modules: [Pagination],
			// loop: slidesCount > 5,
			pagination: {
				el: slidesCount > 5 ? pagination : null,
				clickable: true,
                dynamicBullets: false
			},
            slidesPerGroup: 2,
			spaceBetween: 0,
			speed: 300,
			breakpoints: {
				0: {
					slidesPerView: 2,
					spaceBetween: 0,
				},
				768: {
					slidesPerView: 3,
					spaceBetween: 0,
				},
				1024: {
					slidesPerView: 4,
					spaceBetween: 0,
				},
				1280: {
					slidesPerView: 5,
					spaceBetween: 0,
				},
				1400: {
					slidesPerView: 6,
					spaceBetween: 0,
				},
			},
		});
	});
};
swiperTimeline('.b-timeline__carousel');
